import { useState } from "react";
import AuthenticateYourId from "../../pages/onboarding/authenticateYourId";
import DocumentScanning from "../../pages/onboarding/documentScanning";

const FullidAuthentication = ({ user, isGuarantor, setShowKycPopup }) => {
  const [runDetectKycDocs, setRunDetectKycDocs] = useState(true);
  const [showDocScanningStep, setShowDocScanningStep] = useState(false);
  const [addedFiles, setAddedFiles] = useState([]);

  return (
    <div>
      <AuthenticateYourId
        formHandler={() => {}}
        user={user}
        isGuarantor={isGuarantor}
        updateUserProfile={() => {}}
        setRunDetectKycDocs={setRunDetectKycDocs}
        usedFor={"popup"}
        setShowKycPopup={setShowKycPopup}
        setShowDocScanningStep={setShowDocScanningStep}
        addedFiles={addedFiles}
        setAddedFiles={setAddedFiles}
      />
      {showDocScanningStep && (
        <DocumentScanning
          user={user}
          formHandler={() => {}}
          updateUserProfile={() => {}}
          isGuarantor={isGuarantor}
          runDetectKycDocs={runDetectKycDocs}
          usedFor={"popup"}
          setShowDocScanningStep={setShowDocScanningStep}
          setShowKycPopup={setShowKycPopup}
          setAddedFiles={setAddedFiles}
        />
      )}
    </div>
  );
};

export default FullidAuthentication;
